import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import React from 'react'

import Link, { LinkProps } from '~/components/UI/Link'

import useLocale from '~/hooks/useLocale'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface PaginationProps {
  className?: string
  linkClassName?: string
  activeClassName?: string
  maxPage?: number
  shallow?: LinkProps['shallow']
}

function Pagination({
  className,
  linkClassName,
  activeClassName,
  maxPage,
  shallow = false,
}: PaginationProps) {
  const { pathname, query } = useRouter()
  const locale = useLocale()
  const first = 1
  const last = maxPage
  const current = query?.page ? (+query?.page as number) : 1

  return (
    <div className={cx(css.Pagination, className)}>
      {current !== first && (
        <Link
          className={linkClassName}
          shallow={shallow}
          href={{
            pathname,
            query: { ...query, page: first },
          }}
          locale={locale}
        >
          {first}
        </Link>
      )}
      {current !== first && current - 1 !== first && (
        <>
          <span className={linkClassName}>...</span>
          <Link
            className={linkClassName}
            shallow={shallow}
            href={{
              pathname,
              query: { ...query, page: current - 1 },
            }}
            locale={locale}
          >
            {current - 1}
          </Link>
        </>
      )}

      <Link
        className={cx(linkClassName, activeClassName)}
        shallow={shallow}
        href={{
          pathname,
          query: { ...query, page: current },
        }}
        locale={locale}
      >
        {current}
      </Link>

      {current !== last && current + 1 !== last && (
        <>
          <Link
            className={linkClassName}
            shallow={shallow}
            href={{
              pathname,
              query: { ...query, page: current + 1 },
            }}
            locale={locale}
          >
            {current + 1}
          </Link>
          <span className={linkClassName}>...</span>
        </>
      )}
      {current !== last && (
        <Link
          className={linkClassName}
          shallow={shallow}
          href={{
            pathname,
            query: { ...query, page: last },
          }}
          locale={locale}
        >
          {last}
        </Link>
      )}
    </div>
  )
}

Pagination.defaultProps = {}

export default Pagination
